import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-V8WDGHQ0HC' },
  params: { anonymize_ip: true }
})
